module.exports = __webpack_public_path__ + "static/img/8.c79ef60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/8.png
// module id = lRDp
// module chunks = 0